import { Box, Container } from "@mui/material";
import React from "react";
import AppContainer from "./AppContainer";

const AuthContainer = ({ children }) => {
  return (
    <Box
      height={"100vh"}
      display={"flex"}
      justifyContent={"center"}
      alignItems={"center"}
    >
      <Container sx={{ maxWidth: "450px !important" }}>
        <AppContainer
          styleProps={{
            p: 4,
            width: "100%",
            boxShadow: "0px 0px 12px 0px #003B9554",
          }}
        >
          {children}
        </AppContainer>
      </Container>
    </Box>
  );
};

export default AuthContainer;
